import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getBuilders, getSellers } from '../../../selectors/newbuilding';
import { IBuilder } from '../../../types/newbuilding/builder';
import { ISeller } from '../../../types/newbuilding/seller';
import { BuilderChatCallContainer } from '../../BuilderChatCallContainer';

export function useChatButtonContextValue(forcedContacts?: { builders: IBuilder[]; sellers: ISeller[] }) {
  const builders = useSelector(getBuilders);
  const sellers = useSelector(getSellers);

  return useMemo(
    () => ({
      builders,
      sellers,
      ...forcedContacts,
      CallComponent: BuilderChatCallContainer,
    }),
    [builders, sellers, forcedContacts],
  );
}
